export default function Label({ text, text2, isRequired = false, forId, style }) {
  return (
    <label className={`col-form-label unselectable ${style}`} htmlFor={forId}>
      <span className=''>{text}</span>
      {text2 && <span className='text-muted' style={{fontSize: '12px'}}>{text2}</span>}
      {isRequired && <span className='text-danger'> *</span>}
    </label>
  );
}
